import { createContext, useContext } from 'react';
import PlausibleProvider from 'next-plausible';
import usePlausibleAnalytics from './usePlausibleAnalytics.hook';

const isDev = process.env.NODE_ENV == 'development';

const PlausibleContext = createContext();

export default function PlausibleAnalytics({ children }) {
  const { state, actions } = usePlausibleAnalytics();
  return (
    <PlausibleProvider
      domain={isDev ? 'localhost' : 'rockalingua.com'}
      customDomain="https://plausible.rockalingua.com"
      selfHosted
      trackLocalhost
      enabled
      manualPageviews
    >
      <PlausibleContext.Provider value={{ state, actions }}>
        {children}
      </PlausibleContext.Provider>
    </PlausibleProvider>
  );
}

export const usePlausibleContext = () => useContext(PlausibleContext);
